// extracted by mini-css-extract-plugin
module.exports = {"required":"FormCheckbox_required_1h6ct","error":"FormCheckbox_error_2rAVF","checkbox":"FormCheckbox_checkbox_INn_Z","label":"FormCheckbox_label_1Vnhk"};